// Centralised localStorage preferences store.
// All app preferences live under a single JSON key so reads/writes are atomic
// and the namespace is isolated from other localStorage consumers.
//
// Usage:
//   import { getPref, setPref } from '../../utils/userPrefs';
//   const show = getPref('showFaceBoxes', true);
//   setPref('showFaceBoxes', false);

const PREFS_KEY = 'cm_user_prefs';

function _read() {
  try {
    return JSON.parse(localStorage.getItem(PREFS_KEY) || '{}');
  } catch {
    return {};
  }
}

function _write(prefs) {
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch {
    // storage unavailable (private browsing quota, etc.)
  }
}

export function getPref(key, defaultValue = undefined) {
  const prefs = _read();
  return Object.prototype.hasOwnProperty.call(prefs, key) ? prefs[key] : defaultValue;
}

export function setPref(key, value) {
  _write({ ..._read(), [key]: value });
}

export function removePref(key) {
  const prefs = _read();
  delete prefs[key];
  _write(prefs);
}

export function clearPrefs() {
  try {
    localStorage.removeItem(PREFS_KEY);
  } catch {
    // ignore
  }
}
